import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = [
      "leadSource",
      "otherSourceDetail",
      "otherSourceDetailWrapper",
      "liveSourceDetail",
      "liveSourceDetailWrapper"
    ];

    onSourceChange() {
      this.hideAllConditionalFields();

      if (this.leadSourceTarget.value === 'other') {
        this.otherSourceDetailTarget.disabled = '';
        this.otherSourceDetailWrapperTarget.hidden = false;
      }

      if (this.leadSourceTarget.value === 'live event/conference') {
        this.liveSourceDetailTarget.disabled = '';
        this.liveSourceDetailWrapperTarget.hidden = false;
      }
    }

    hideAllConditionalFields() {
      this.otherSourceDetailTarget.disabled = 'disabled';
      this.otherSourceDetailWrapperTarget.hidden = true;
      this.liveSourceDetailTarget.disabled = 'disabled';
      this.liveSourceDetailWrapperTarget.hidden = true;
    }
}
